import { Link } from "react-router-dom";
import { LOGO_MARK } from "@/lib/data";
import { Instagram } from "lucide-react";

export const Footer = () => (
  <footer data-testid="site-footer" className="relative bg-[#050505] border-t border-white/10 pt-20 pb-10 overflow-hidden">
    <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 pb-16">
        <div className="lg:col-span-5">
          <img src={LOGO_MARK} alt="DVG" className="h-16 w-auto mb-6" />
          <p className="text-white/55 max-w-md text-base leading-relaxed">
            DVG Sports empowers athletes and families to win the business of sports through trusted representation, strategic negotiation, and a relentless David vs. Goliath mindset.
          </p>
        </div>
        <div className="lg:col-span-3 lg:col-start-7">
          <h4 className="text-[12px] uppercase tracking-[0.2em] text-white/40 mb-5">Navigate</h4>
          <ul className="space-y-3">
            {[["Home", "/"], ["Team", "/team"]].map(([l, to]) => (
              <li key={l}>
                <Link to={to} className="text-white/80 hover:text-[#cbd1d8] transition-colors">{l}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="lg:col-span-3">
          <h4 className="text-[12px] uppercase tracking-[0.2em] text-white/40 mb-5">Contact</h4>
          <a href="mailto:info@dvgsports.net" className="block text-white/80 hover:text-[#cbd1d8] transition-colors mb-3">info@dvgsports.net</a>
          <div className="flex gap-4 mt-6">
            <a href="https://www.instagram.com/dvgsports_" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="w-10 h-10 border border-white/15 flex items-center justify-center text-white/70 hover:text-black hover:bg-[#cbd1d8] hover:border-[#cbd1d8] transition-colors duration-300">
              <Instagram size={17} />
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 pt-8 border-t border-white/10">
        <p className="text-white/35 text-sm">© {new Date().getFullYear()} DVG Sports. All rights reserved.</p>
        <p className="text-white/35 text-sm uppercase tracking-[0.2em]">David vs. Goliath</p>
      </div>
    </div>
  </footer>
);
